import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { REQUEST_DELETE_MASTER_CASESTUDY } from "../../store/casestudy/casestudyActionTypes";
import { useCasestudyMaster } from "../../store/casestudy/reducer";
interface RestaurantDeleteProps {
  bannerData: any;
  // bannerData: any;
  isOpen: boolean;
  // onClose: () => void;
  onDeleteClose: () => void;
  refreshData?: () => void;
  // refreshData?: any[];
  categoryFilter?: string;
}
const CasestudyDeleteConfirmation: React.FC<RestaurantDeleteProps> = ({
  isOpen,
  // onClose,
  bannerData,
  onDeleteClose,
  refreshData,
  categoryFilter,
}) => {
  const dispatch = useDispatch();
  const { masterCasestudy: events, busy, message } = useCasestudyMaster();
  const toast = useToast();
  console.log("bannerData", bannerData);

  // useEffect(() => {
  //   const findEvent = events.find(
  //     (val: Record<string, any>) => val._id === bannerData.caseStydyId
  //   );
  //   console.log("val", findEvent);

  //   if (!findEvent) {
  //     toast({
  //       title: "Success.",
  //       description: "selected casestudy is deleted.",
  //       status: "success",
  //       isClosable: true,
  //       position: "top-right",
  //     });
  //     onClose();
  //   }
  // }, [bannerData, events, onClose]);

  const handleDelete = () => {
    const _id = bannerData?.caseStydyId;
    dispatch({
      type: REQUEST_DELETE_MASTER_CASESTUDY,
      payload: { _id: _id },
      onSuccess: () => {
        toast({
          title: "Success",
          description: "casestudy has been deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
        onDeleteClose();
        if (refreshData) {
          refreshData();
        }
        // onClose();
        // dispatch({
        //   type: "REQUEST_MASTER_CASESTUDY",
        //   payload: {
        //     type: categoryFilter,
        //   },
        //   onSuccess: (response: any) => {
        //     console.log("Refreshed casestudy successfully:", response);
        //     onDeleteClose();
        //   },
        //   onError: (error: any) => {
        //     console.error("Error refreshing casestudy:", error);
        //   },
        // });
      },
      onError: (error: any) => {
        toast({
          title: "Error",
          description: error?.message || "Failed to delete casestudy.",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      },
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onDeleteClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete selected casestudy</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this Restaurant?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="outline"
            mr={3}
            onClick={onDeleteClose}
            disabled={busy}
          >
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={handleDelete}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon /> <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
export default CasestudyDeleteConfirmation;
